import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceCTA.css';

const ServiceCTA = ({
  heading = "From Concept to Institution, Mastered.",
  description = "Build compliant medical colleges and teaching hospitals that deliver measurable academic and clinical excellence.",
  buttonText = "Talk to Our Advisory Experts",
  buttonLink = "/contact"
}) => {
  const handleScroll = (e) => {
    if (buttonLink && buttonLink.startsWith("#")) {
      e.preventDefault();
      const targetId = buttonLink.replace("#", "");
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <section className="service-cta-section">
      <div className="service-cta-container">
        
        {/* Contained Radiant Card */}
        <div className="service-cta-card">
          
          {/* Ambient Glows */}
          <div className="service-cta-glow-circle"></div>

          <div className="service-cta-wrapper">
            
            {/* LEFT: Content */}
            <div className="service-cta-content">
              {heading && (
                <h2 className="service-cta-title">
                  {heading}
                </h2>
              )}

              {description && (
                <p className="service-cta-subtitle">
                  {description}
                </p>
              )}
            </div>

            {/* RIGHT: Action Button with Navbar-style Hover Fill */}
            {buttonText && (
              <div className="service-cta-actions">
                {buttonLink.startsWith("#") ? (
                  <a 
                    href={buttonLink} 
                    onClick={handleScroll} 
                    className="service-cta-btn"
                  >
                    <span>{buttonText}</span>
                    <svg 
                      className="service-cta-btn-arrow" 
                      width="18" 
                      height="18" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2.4" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  </a>
                ) : (
                  <Link 
                    to={buttonLink} 
                    className="service-cta-btn"
                  >
                    <span>{buttonText}</span>
                    <svg 
                      className="service-cta-btn-arrow" 
                      width="18" 
                      height="18" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2.4" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  </Link>
                )}
              </div>
            )}

          </div>

        </div>

      </div>
    </section>
  );
};

export default ServiceCTA;